
const input = document.getElementById('input_file');

if (input) {
  const FileInput = document.getElementById('input_file');
  const textFileInput = document.getElementById('text_input_file');

  FileInput.addEventListener('change', () => {
    textFileInput.innerText = FileInput.value.split(/(\\|\/)/g).pop();
  });
}




// WEBPACK FOOTER //
// ./scripts/modules/form.js